module.exports = __webpack_public_path__ + "static/media/mr.static.9372d768.svg";